import React, { useState } from 'react';
import * as cn from 'classnames';
import PropTypes from 'prop-types';
import Form from '../../components/Form';
import { Fields } from '../../components/Fields';
import Button from '../../components/Button';

// Helpers
import { toastSuccess, toastError } from '../../../helpers';

function ContactForm({ className, onSubmitText, onSubmit, ...props }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    let data = {
      name: `${firstName} ${lastName}`,
      email,
      message,
    };

    onSubmit(data, (res, success) => {
      if (success) {
        toastSuccess('Great Job!', 'Successfully sent messege!');
        setFirstName('');
        setLastName('');
        setEmail('');
        setMessage('');
      } else {
        toastError('Uh Oh!', res?.text);
      }
    });
  };

  return (
    <div
      className={cn('contact-form', { [className]: !!className })}
      {...props}
    >
      <Form onSubmit={(e) => handleSubmit(e)}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group mb-2">
              <label className="small">
                First Name <span className="text-danger">*</span>
              </label>
              <Fields
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="form-control"
                required
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group mb-2">
              <label className="small">
                Last Name <span className="text-danger">*</span>
              </label>
              <Fields
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="form-control"
                required
              />
            </div>
          </div>
        </div>
        <div className="form-group mb-2">
          <label className="small">
            Email Address <span className="text-danger">*</span>
          </label>
          <Fields
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-control"
            required
          />
        </div>
        <div className="form-group mb-3">
          <label className="small">
            Message <span className="text-danger">*</span>
          </label>
          <textarea
            rows="5"
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="form-control"
            required
          ></textarea>
        </div>
        <Button
          text={onSubmitText}
          type="submit"
          className="btn btn-secondary"
        />
      </Form>
    </div>
  );
}

ContactForm.defaultProps = {
  className: '',
  onSubmitText: '',
  onSubmit: () => {},
};

ContactForm.propTypes = {
  className: PropTypes.string,
  onSubmitText: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default React.memo(ContactForm);
